/*
    Слайдер текстовый
*/

class SliderText {
    constructor(slider) {
        this.$slider = $(slider);
        this.$container = this.$slider.closest('.js-slider-wrap');

        this.init();
    }



    init() {
        // Инициализация слайдера
        this.swiper = new Swiper(this.$slider, {
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: this.$container.find('.js-slider-next'),
                prevEl: this.$container.find('.js-slider-prev')
            },
            pagination: {
                'el': this.$container.find('.js-slider-pagination'),
                'type': 'bullets',
                'bulletClass': 'pagination__li',
                'bulletActiveClass': '_active',
                'renderBullet': (index, className) => {
                    return `<li class="${className}">${index + 1}</li>`;
                },
                'clickable': true
            },
            threshold: 10,
            roundLengths: true,
            speed: 500,
            a11y: true,
            grabCursor: false,
            simulateTouch: true
        });
    }
}



App.H.find('.js-slider-text').each(function() {
    if ($(this).find('.slide').length > 1) {
        new SliderText(this);
    } else {
        $(this).closest('.js-slider-wrap').addClass('no-pagination');
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/SliderText.js